import React from 'react';
import { useSelector } from 'react-redux';
import Layout from '../../../layout';
import { EDevice } from '../../../redux/sequence/enums';
import { RootState } from '../../../redux/store';
import ArrowList from '../../b2b/components/arrow-list/arrow-list';
import OldButton from '../../b2b/components/button/button';
import Contact from '../contact/contact';
import { ReactComponent as GeneralErrorSvg } from '/src/assets/svg/general_error.svg';
import { ReactComponent as GeneralErrorSmallSvg } from '/src/assets/svg/general_error_small.svg';

const StatusTimedout: React.FC = () => {
  const { device } = useSelector((state: RootState) => state.sequence);

  const headline = (
    <>
      {device === EDevice.MOBILE && (
        <GeneralErrorSmallSvg className='status-svg mb-6' />
      )}
      <div>Dein Leasingantrag wurde beendet</div>
    </>
  );

  const getSubHeading = () => {
    return 'Da die erforderlichen Schritte nicht innerhalb der vorgesehenen Frist abgeschlossen wurden, wurde dein Leasingantrag automatisch beendet.';
  };

  return (
    <Layout
      heading={headline}
      subHeading={getSubHeading()}
      hasFullSize={true}
      className='status-overview top-96 grid'
      style={{ gridTemplateRows: '15% 60%' }}
    >
      <div
        className='half-half-columns cancelled top-36'
        style={{ alignItems: 'start' }}
      >
        {(device === EDevice.DESKTOP || device === EDevice.TABLET) && (
          <GeneralErrorSvg className='status-svg' />
        )}
        <div className='flex flex-col gap-4'>
          <div className='content-bold'>Was du jetzt tun kannst</div>

          <ArrowList
            className='dark-grey content-normal'
            list={[
              'Dein bisheriger Leasingantrag kann nicht mehr fortgeführt werden.',
              'Über den Button gelangst du zurück zur Fahrzeugauswahl und kannst jederzeit ein neues Angebot auswählen.',
            ]}
          />

          <OldButton
            type='button'
            onClick={() => window.open(import.meta.env.VITE_MOPO_URL, '_self')}
            style={{
              width: '100%',
              marginTop: '18px',
              marginBottom: '18px',
            }}
          >
            <span className='content-bold text-base!'>Zur Fahrzeugsuche</span>
          </OldButton>

          <Contact />
        </div>
      </div>
    </Layout>
  );
};

export default StatusTimedout;
